import { Box, Typography } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

const StyledWrapper = styled(Box)``;

const StyledName = styled(Typography)`
  font-size: 0.9375rem;
  font-weight: 600;
`;

const StyledDetailWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledCrmName = styled(Typography)`
  font-size: 0.75rem;
  font-weight: 400;
  margin-right: 0.5rem;
`;

const StyledCif = styled(Typography)`
  font-size: 0.75rem;
  font-weight: 400;
`;

interface IEmployerDetail {
  employer: {
    id: string;
    Nombre_y_Apellidos_Empleador?: string;
    DNI?: string;
    Name?: string;
  };
}

const EmployerDetail = (props: IEmployerDetail) => {
  const { employer } = props;

  return (
    <StyledWrapper>
      <StyledName>{employer.Nombre_y_Apellidos_Empleador}</StyledName>
      <StyledDetailWrapper>
        <StyledCrmName>{employer.Name}</StyledCrmName>
        <StyledCif>{employer.DNI}</StyledCif>
      </StyledDetailWrapper>
    </StyledWrapper>
  );
};

export default EmployerDetail;
